import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const GooglePlay = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" {...props}>
    <path
      d="M15.3813 16.5884L11.5 12.7071L3.31368 20.8935C3.3888 21.018 3.47585 21.1355 3.57386 21.2442C3.80576 21.5013 4.09296 21.7024 4.41384 21.8324C4.73473 21.9625 5.08093 22.018 5.42639 21.9949C5.77186 21.9718 6.10757 21.8706 6.40825 21.6989L15.3813 16.5884Z"
      fill="currentColor"
    />
    <path
      d="M16.2876 16.0805L12.2071 12L16.2611 7.94608L19.9536 10.0609H19.9411C20.3404 10.2729 20.6671 10.5996 20.8791 10.9989C21.015 11.2571 21.0985 11.5395 21.1249 11.83C21.1512 12.1205 21.1199 12.4133 21.0328 12.6917C20.9456 12.97 20.8043 13.2284 20.6169 13.452C20.4296 13.6756 20.1999 13.8599 19.9411 13.9944L16.2876 16.0805Z"
      fill="currentColor"
    />
    <path
      d="M15.362 7.43099L11.5 11.2929L3.31314 3.10603C3.46251 2.85683 3.65917 2.63692 3.894 2.45962C4.29029 2.16043 4.77354 1.99902 5.27009 2C5.6812 2.00141 6.08463 2.11143 6.43952 2.31894L15.362 7.43099Z"
      fill="currentColor"
    />
    <path
      d="M3.0002 4.20731C3.00006 4.2178 2.99999 4.22829 3 4.23878V19.7728C3 19.7795 3.00002 19.7862 3.00008 19.7929L10.7929 12L3.0002 4.20731Z"
      fill="currentColor"
    />
  </Icon>
));

export default GooglePlay;
